export class DetailLabel {
  name;
  value;
  type;
  currencyCode;
  urlLink: string;
  hasLink: boolean;
  hasLinkToSameTab: boolean;
  isPowerOfAttorney: boolean;

  constructor(name: any, value?: any, type?: string, currencyCode?: string) {
    this.name = name;
    this.value = value;
    this.type = type;
    this.currencyCode = currencyCode;
  }

  public getName() {
    return this.name;
  }

  public getValue() {
    return this.value;
  }

  public setValue(value: any) {
    this.value = value;
  }

  public setType(type: string) {
    this.type = type;
  }

  public setCurrencyCode(currencyCode: string) {
    this.currencyCode = currencyCode;
  }

  public setUrlLink(url: string) {
    this.urlLink = url;
  }

  public setHasLink(val: boolean) {
    this.hasLink = val;
  }

  public getHasLink() {
    return this.hasLink;
  }

  public setHasLinkToSameTab(val: boolean) {
    this.hasLinkToSameTab = val;
  }

  public getHasLinkToSameTab() {
    return this.hasLinkToSameTab;
  }

 public getIsPowerOfAttorney() {
    return this.isPowerOfAttorney;
  }

  public setIsPowerOfAttorney(poa: boolean) {
    this.isPowerOfAttorney = poa;
  }
}
